import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { AiOutlineHeart, AiOutlineShoppingCart } from "react-icons/ai";
import { FiSearch } from "react-icons/fi";
import { BiMenuAltLeft } from "react-icons/bi";
import DropDown from "./DropDown";
import Navbar from "./Navbar";
import Cart from "./Cart";
import Wishlist from "./Wishlist";
import "./Header.scss";

const Header = ({ activeHeading }) => {
  const { wishlist } = useSelector((state) => state.wishlist);
  const { cart } = useSelector((state) => state.cart);
  const { allProducts } = useSelector((state) => state.products);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [searchExpanded, setSearchExpanded] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  const [openWishlist, setOpenWishlist] = useState(false);
  const [open, setOpen] = useState(false);

  const toggleRef = useRef(null);
  const searchRef = useRef(null);

  const handleSearchChange = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (allProducts && term.trim().length > 0) {
      const filteredProducts = allProducts.filter((product) =>
        product.name.toLowerCase().includes(term)
      );
      setSearchData(filteredProducts);
    } else {
      setSearchData([]);
    }
  };

  const handleSearchIconClick = () => {
    setSearchExpanded(!searchExpanded);
    if (searchExpanded) {
      
      setSearchTerm("");
      setSearchData([]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchExpanded) {
        if (
          searchRef.current &&
          !searchRef.current.contains(event.target) &&
          !event.target.matches(".search-toggle")
        ) {
          setSearchExpanded(false);
          setSearchTerm("");
          setSearchData([]);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchExpanded]);

  return (
    <>
      <div className="header-desktop">
        <div className="header-desktop-inner">
          <div className="header-logo">
            <Link to="/">
              <img
                src="https://res.cloudinary.com/dgvb7ghfd/image/upload/f_auto,q_auto/sswyskszdqd6tqkt0pq7"
                alt=""
              />
            </Link>
          </div>

          <div className="header-actions">
            <div
              className={`header-search ${searchExpanded ? "open" : ""}`}
              ref={searchRef}
            >
              <input
                type="text"
                placeholder="Пошук продуктів..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <div className="search-results">
                {searchExpanded && searchTerm.trim().length > 0 ? (
                  searchData && searchData.length > 0 ? (
                    searchData.map((i, index) => (
                      <Link to={`/product/${i._id}`} key={index}>
                        <div className="search-item">
                          <img src={`${i.images[0]?.url}`} alt="" />
                          <h1>{i.name}</h1>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <div className="search-item no-results">
                      <h1>Результатів не знайдено :(</h1>
                    </div>
                  )
                ) : null}
              </div>
            </div>
            <FiSearch
              className="search-icon-right search-toggle" 
              size={18}
              onClick={handleSearchIconClick}
            />
            <div
              className="catalog"
              ref={toggleRef}
              onClick={() => setDropDown(!dropDown)}
            >
              <button className="catalog-btn">
                <BiMenuAltLeft className="catalog-icon" size={20} />
                Каталог
              </button>
              {dropDown && (
                <DropDown setDropDown={setDropDown} toggleRef={toggleRef} />
              )}
            </div>

            <div
              className="wishlist-icon"
              onClick={() => setOpenWishlist(true)}
            >
              <AiOutlineHeart size={25} />
              <span>{wishlist && wishlist.length}</span>
            </div>

            <div className="cart-icon" onClick={() => setOpenCart(true)}>
              <AiOutlineShoppingCart size={25} />
              <span>{cart && cart.length}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="header-mobile">
        {open && (
          <div className="mobile-dropdown">
            <Navbar
              active={activeHeading}
              mobile={true}
              onClose={() => setOpen(false)}
            />
          </div>
        )}
        <div className="mobile-menu" onClick={() => setOpen(!open)}>
          <BiMenuAltLeft size={25} />
        </div>
        <div className="mobile-logo">
          <Link to="/">
            <img
              src="https://res.cloudinary.com/dgvb7ghfd/image/upload/f_auto,q_auto/sswyskszdqd6tqkt0pq7"
              alt=""
            />
          </Link>
        </div>
        <div className="mobile-wish" onClick={() => setOpenWishlist(true)}>
          <AiOutlineHeart size={25} />
          <span>{wishlist && wishlist.length}</span>
        </div>
        <div className="mobile-cart" onClick={() => setOpenCart(true)}>
          <AiOutlineShoppingCart size={25} />
          {cart && cart.length > 0 && <span>{cart.length}</span>}
        </div>
      </div>

      {openCart && <Cart setOpenCart={setOpenCart} />}
      {openWishlist && <Wishlist setOpenWishlist={setOpenWishlist} />}
    </>
  );
};

export default Header;
